import { render, staticRenderFns } from "./UpsertPriorityCart.vue?vue&type=template&id=263782e2&scoped=true"
import script from "./UpsertPriorityCart.vue?vue&type=script&lang=js"
export * from "./UpsertPriorityCart.vue?vue&type=script&lang=js"
import style0 from "./UpsertPriorityCart.vue?vue&type=style&index=0&id=263782e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "263782e2",
  null
  
)

export default component.exports